@file:OptIn(InternalResourceApi::class)

package heyagenda.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/heyagenda.shared.generated.resources/"

@delegate:ResourceContentHash(-1_424_386_029)
internal val Res.drawable.wine: DrawableResource by lazy {
      DrawableResource("drawable:wine", setOf(
        ResourceItem(setOf(), "${MD}drawable/wine.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_310_897_576)
internal val Res.drawable.wrench: DrawableResource by lazy {
      DrawableResource("drawable:wrench", setOf(
        ResourceItem(setOf(), "${MD}drawable/wrench.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_817_828_818)
internal val Res.drawable.x: DrawableResource by lazy {
      DrawableResource("drawable:x", setOf(
        ResourceItem(setOf(), "${MD}drawable/x.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_058_611_524)
internal val Res.drawable.x_circle: DrawableResource by lazy {
      DrawableResource("drawable:x_circle", setOf(
        ResourceItem(setOf(), "${MD}drawable/x_circle.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_009_446_516)
internal val Res.drawable.x_logo: DrawableResource by lazy {
      DrawableResource("drawable:x_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/x_logo.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-699_737_661)
internal val Res.drawable.yarn: DrawableResource by lazy {
      DrawableResource("drawable:yarn", setOf(
        ResourceItem(setOf(), "${MD}drawable/yarn.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_686_159_105)
internal val Res.drawable.yin_yang: DrawableResource by lazy {
      DrawableResource("drawable:yin_yang", setOf(
        ResourceItem(setOf(), "${MD}drawable/yin_yang.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_825_574_441)
internal val Res.drawable.youtube_logo: DrawableResource by lazy {
      DrawableResource("drawable:youtube_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/youtube_logo.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable13Resources(map: MutableMap<String, DrawableResource>) {
  map.put("wine", Res.drawable.wine)
  map.put("wrench", Res.drawable.wrench)
  map.put("x", Res.drawable.x)
  map.put("x_circle", Res.drawable.x_circle)
  map.put("x_logo", Res.drawable.x_logo)
  map.put("yarn", Res.drawable.yarn)
  map.put("yin_yang", Res.drawable.yin_yang)
  map.put("youtube_logo", Res.drawable.youtube_logo)
}
